module.exports = __webpack_public_path__ + "img/cordoba_general.17c68cef.svg";